<template lang="html">
  <div class="profile-my-purchases-mobile-wrapper">
    <div class="actions-wrapper">
      <div @click="navigateToHome()" class="btn dark-blue">
        <img src="@/assets/icons/plusWhite.png" alt="trash icon" />
        <span style="white-space: nowrap; font-size: 17px;">{{
          $t("profile.purchase.newPurchase")
        }}</span>
      </div>
      <div class="search-wrapper">
        <InputView
          @keyup="(page = 1), getMyPurchases()"
          v-model="search"
          type="text"
          :label="$t('nav.search')"
          name=""
          value=""
          icon="mdi:search"
        />
      </div>
      <dropdown
        :defaultText="$t('dropdown.sort')"
        :selected="sortSelected"
        :list="sortList"
        :removable="true"
        class="full-width"
        @remove="(sortSelected = null), getMyPurchases()"
        @changeOption="(sortSelected = $event), getMyPurchases()"
      />
    </div>
    <table v-if="purchases.length > 0">
      <tbody>
        <template v-for="(purchase, index) in purchases">
          <tr
            :class="{
              deleted: purchase.archived === 1 || purchase.expired === 1
            }"
            :key="index"
            @click="purchase.open = !purchase.open"
          >
            <td>
              <span class="bold-td-text">{{ purchase.pro_name }}</span>
              <br />
              <span class="regular-td-text">{{ purchase.usr_name }}</span>
              <br />
              <span class="light-grey">{{
                purchase.pro_expiry.substring(0, 10)
              }}</span>
            </td>
            <td class="status-color flex-center-right">
              <span
                class="iconsRemove"
                v-if="purchase.editable === 1"
                @click="openChangeOfferModal(purchase, $event)"
              >
                <img
                  :title="$t('main.edit')"
                  src="@/assets/icons/pen.png"
                  alt="pen icon"
                />
              </span>
              <span
                class="iconsRemove"
                v-if="
                  purchase.off_status === 1 &&
                    purchase.archived === 0 &&
                    purchase.expired === 0 &&
                    purchase.sold_out === 0
                "
                @click="openConfirmModalReject(purchase, $event)"
              >
                <img
                  :title="$t('main.giveUp')"
                  src="@/assets/icons/reject.png"
                  alt="reject icon"
                />
              </span>
              <!-- span  class="spanNull" v-else></span -->
              <!--span v-if="purchase.off_status === 1 && purchase.archived === 0 && purchase.expired === 0 && purchase.sold_out === 0" @click="openConfirmModal(purchase, $event)">
                <img :title="$t('main.giveUp')" src="@/assets/icons/closeRed.png" alt="x icon">
              </span -->
              <!-- span class="spanNull" v-else></span -->
              <div
                class="icon-wrapper remove-btn"
                v-if="purchase.can_hide === 1"
                @click="archive(purchase, $event)"
              >
                <img
                  style="height: 10px;"
                  src="@/assets/icons/closeRed.png"
                  alt="eye icon"
                />
              </div>
            </td>
          </tr>
          <tr
            :class="{
              deleted: purchase.archived === 1 || purchase.expired === 1
            }"
            :key="index + 'm'"
            @click="purchase.open = !purchase.open"
          >
            <td class="regular-td-text">
              {{ purchase.off_quantity }} komada
              <span class="light-grey"
                >( {{ purchase.prc_price }} {{ purchase.cur_id }} )</span
              >
            </td>
            <td class="status-color">
              <TagDisplay
                :color="
                  getTagColor(
                    purchase.off_status,
                    purchase.sold_out,
                    purchase.expired
                  )
                "
              >
                {{
                  getStatus(
                    purchase.off_status,
                    purchase.sold_out,
                    purchase.expired
                  )
                }}
              </TagDisplay>
            </td>
          </tr>
          <tr
            class="dropdown-row"
            :key="index + 'd'"
            :class="{ active: purchase.open }"
          >
            <td colspan="100%">
              <div class="dropdown">
                <div class="dropdown-header">
                  <div class="header">
                    {{ $t("profile.purchase.details") }}
                  </div>
                  <div
                    @click="openOffersList(purchase)"
                    class="btn dark-blue outlined"
                  >
                    {{ $t("profile.purchase.otherList") }}
                  </div>
                </div>
                <div class="info-wrapper">
                  <div class="left">
                    <div class="info">
                      <span class="info-key"
                        >{{ $t("profile.purchase.purchaseTerms") }}:</span
                      >
                      <div class="info-value">
                        {{ getTranslation(purchase.off_type) }}
                      </div>
                    </div>
                    <div class="info">
                      <span class="info-key"
                        >{{ $t("profile.purchase.offeredPrice") }}:</span
                      >
                      <div class="info-value">
                        {{ purchase.prc_price }} {{ purchase.cur_id }}
                      </div>
                    </div>
                    <div class="info">
                      <span class="info-key"
                        >{{ $t("profile.purchase.sellerRating") }}:</span
                      >
                      <div class="info-value">
                        <rating :rating="parseFloat(purchase.usr_rating)" />
                      </div>
                    </div>
                  </div>
                  <div class="right">
                    <div class="info" v-if="seeExpiry(purchase.pro_expiry)">
                      <span class="info-key"
                        >{{ $t("profile.purchase.shareProduct") }}:</span
                      >
                      <div class="info-value iconsVal">
                        <ShareNetwork
                          network="Facebook"
                          :url="createUrl(purchase.pro_id)"
                          :title="purchase.pro_name"
                          :description="purchase.pro_description"
                          :quote="purchase.pro_description"
                          hashtags="eBerza"
                        >
                          <img
                            style="cursor: pointer; margin-right: 5px"
                            :src="require('@/assets/icons/facebook.png')"
                            alt="facebook logo"
                          />
                        </ShareNetwork>
                        <ShareNetwork
                          network="Twitter"
                          :url="createUrl(purchase.pro_id)"
                          :title="purchase.pro_name"
                          :description="purchase.pro_description"
                          :quote="purchase.pro_description"
                          hashtags="eBerza"
                        >
                          <img
                            style="cursor: pointer; width:26px;"
                            :src="require('@/assets/icons/XLogo.png')"
                            alt="twitter logo"
                          />
                        </ShareNetwork>
                        <ShareNetwork
                          network="email"
                          :url="
                            $t('txtemail') + createUrl(purchase.pro_id) + '\n'
                          "
                          :title="purchase.pro_name"
                          :description="
                            purchase.pro_description + $t('txtemail2')
                          "
                          :quote="purchase.pro_description"
                          hashtags="eBerza"
                        >
                          <img
                            class="imgShareIcon"
                            :src="require('@/assets/icons/sharemail.png')"
                            alt="email share"
                          />
                        </ShareNetwork>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dropdown-header">
                  <div class="header">
                    {{ $t("profile.purchase.rateSeller") }}
                  </div>
                </div>
                <div class="rate-wrapper">
                  <div class="info rate">
                    <span class="info-key">
                      {{ $t("profile.purchase.rate") }}
                      :
                    </span>
                    <rate-user
                      :rating="rate"
                      @update-rating="rate = $event"
                    ></rate-user>
                  </div>
                  <div class="info rate">
                    <InputView
                      v-model="comment"
                      max-length="300"
                      type="textarea"
                      :label="$t('profile.purchase.comment')"
                      rows="6"
                    ></InputView>
                  </div>
                  <div
                    style="width: 200px"
                    @click="rateSeller(purchase.off_id)"
                    class="btn dark-blue"
                  >
                    {{ $t("profile.purchase.rateSeller") }}
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <div class="empty" v-else>
      {{ $t("main.noPurchases") }}
    </div>
    <div v-if="purchases.length > 0" class="pagination-wrapper">
      <paginate
        v-model="page"
        :page-count="pageCount"
        :prev-text="getPaginationImages('Left')"
        :next-text="getPaginationImages('Right')"
        :container-class="'pagination'"
        :page-class="'page'"
        :click-handler="changePage"
      >
      </paginate>
    </div>
  </div>
</template>

<script>
import eventBus from "@/shared/eventBus.js";
import Rating from "@/components/rating.vue";
import Dropdown from "@/components/dropdown.vue";
import { api } from "@/api";
import TestInput from "../shared/testInput.vue";
import TagDisplay from "../shared/TagDisplay.vue";
import RateUser from "@/components/shared/RateUser.vue";
export default {
  name: "profileMyPurchasesMobile",
  components: {
    Rating,
    Dropdown,
    InputView: TestInput,
    TagDisplay,
    RateUser
  },
  props: ["_sortSelected", "_search", "_page"],
  data() {
    return {
      purchases: [],
      rate: null,
      comment: null,
      page: 1,
      pageCount: 0,
      search: null,
      sortSelected: null
    };
  },
  mounted() {
    if (this._sortSelected) {
      this.sortSelected = this._sortSelected;
    }
    if (this._search) {
      this.search = this._search;
    }
    if (this._page) {
      this.page = this._page;
    }
    this.getMyPurchases();
  },
  methods: {
    fixRate() {
      if (parseInt(this.rate) > 5) {
        this.rate = 5;
      } else if (parseInt(this.rate) < 1) {
        this.rate = 1;
      }
    },
    getMyPurchases() {
      let params = {
        page: this.page
      };
      if (this.sortSelected) {
        params.sort = this.sortSelected.value;
      }
      if (this.search && this.search !== "") {
        params.search = this.search;
      }
      api
        .getMyPurchases(params)
        .then(res => {
          for (var i = 0; i < res.data.data.length; i++) {
            res.data.data[i].open = false;
          }
          this.pageCount = res.data.page_count;
          this.purchases = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    rateSeller(id) {
      if (this.rate || this.comment) {
        let params = {
          id: id
        };
        if (this.rate) {
          params.rat_rating = this.rate;
        }
        if (this.comment) {
          params.rat_comment = this.comment;
        }
        api
          .rateUser(params)
          .then(res => {
            console.log(res);
            this.$toast.success(this.$t("main.rateSuccess"), {
              duration: 8000
            });
          })
          .catch(e => {
            console.log(e);
            this.$toast.error(this.$t("main.rateError"), {
              duration: 8000
            });
          })
          .finally(() => {
            this.rate = null;
            this.comment = null;
          });
      } else {
        this.$toast.error(this.$t("main.rateError"), {
          duration: 8000
        });
      }
    },
    // openConfirmModal(data, e) {
    //   e.stopPropagation();
    //   let modalData = {
    //     title: this.$t("modal.giveUpOfferTitle"),
    //     ok: () => {
    //       this.changeStatus(data);
    //     },
    //   };
    //   let params = {
    //     modalData: modalData,
    //     component: "confirmModal",
    //   };
    //   eventBus.$emit("openModal", params);
    // },
    openChangeOfferModal(data, e) {
      e.stopPropagation();
      let modalData = {
        title: this.$t("main.changeOffer"),
        id: data.pro_id,
        off_quantity: data.off_quantity,
        off_id: data.off_id,
        ok: () => {
          this.getMyPurchases();
        }
      };
      let params = {
        modalData: modalData,
        component: "changeOffer"
      };
      eventBus.$emit("openModal", params);
    },
    changeStatus(data) {
      let params = {
        id: data.off_id
      };
      api
        .changeOffer(params)
        .then(res => {
          console.log(res);
          this.$toast.success(this.$t("main.giveUpOfferSuccess"), {
            duration: 8000
          });
        })
        .catch(e => {
          console.log(e);
          this.$toast.error(this.$t("main.giveUpOfferError"), {
            duration: 8000
          });
        })
        .finally(() => {
          this.getMyPurchases();
        });
    },
    openOffersList(purchase) {
      let params = {
        modalData: purchase,
        component: "productBuyers"
      };
      eventBus.$emit("openModal", params);
    },
    getStatus(status, soldOut, expired) {
      if (status === 1) {
        if (soldOut === 1 || expired === 1) {
          return this.$t("profile.buyers.statusSoldFinished");
        }
        return this.$t("profile.buyers.statusSold");
      } else if (status === 2) {
        return this.$t("profile.buyers.statusBuyerGaveUp");
      } else if (status === 3) {
        return this.$t("profile.buyers.statusRejected");
      } else if (status === 4) {
        return this.$t("profile.buyers.statusRejectedAdmin");
      } else if (status === 5) {
        return this.$t("profile.buyers.statusContract");
      } else {
        return this.$t("profile.buyers.statusUnknown");
      }
    },
    navigateToHome() {
      this.$router.push({ name: "Berza", params: { lang: this.$i18n.locale } });
    },
    getPaginationImages(side) {
      let path = require(`@/assets/icons/pagination${side}.png`);
      return `<img src='${path}' alt='pagination left image'>`;
    },
    changePage(page) {
      this.page = page;
      this.purchases = [];
      this.getMyPurchases();
    },
    createUrl(id) {
      return (
        document.location.origin + "/" + this.$i18n.locale + "/details/" + id
      );
    },
    archive(data, e) {
      console.log("has");
      e.stopPropagation();
      let modalData = {
        title: this.$t("modal.archiveOffer"),
        ok: () => {
          this.archiveOffer(data);
        }
      };
      let params = {
        modalData: modalData,
        component: "confirmModal"
      };
      eventBus.$emit("openModal", params);
    },
    archiveOffer(data) {
      let params = {
        off_id: data.off_id
      };
      api
        .deleteOfferFromArchive(params)
        .then(res => {
          this.getMyPurchases();
        })
        .catch(e => {
          console.log(e);
        });
    },
    openConfirmModalReject(data, e) {
      e.stopPropagation();
      let modalData = {
        title: this.$t("modal.giveUpOfferTitle"),
        ok: () => {
          this.changeStatus(data);
        }
      };
      let params = {
        modalData: modalData,
        component: "confirmYesNoModal"
      };
      eventBus.$emit("openModal", params);
    },
    seeExpiry(expiry) {
      // 2022-01-30 09:19   - this form parameter get
      // console.log(expiry.substr(0, 4), expiry.substr(5, 2), expiry.substr(8, 2), expiry.substr(11, 2), expiry.substr(14, 2))
      let date = new Date(
        expiry.substr(0, 4),
        expiry.substr(5, 2) - 1,
        expiry.substr(8, 2),
        expiry.substr(11, 2),
        expiry.substr(14, 2)
      );
      return date - new Date() > 1;
    },
    // openConfirmModal(data, e) {
    //   e.stopPropagation();
    //   let modalData = {
    //     title: this.$t("modal.giveUpOfferTitle"),
    //     ok: () => {
    //       this.changeStatus(data);
    //     },
    //   };
    //   let params = {
    //     modalData: modalData,
    //     component: "confirmModal",
    //   };
    //   eventBus.$emit("openModal", params);
    // },
    getTagColor(status, soldOut, expired) {
      if (status === 1) {
        if (soldOut === 1 || expired === 1) {
          return "light-blue";
        }
        return "green";
      } else if (status === 2) {
        return "gray";
      } else if (status === 3) {
        return "red";
      } else if (status === 4) {
        return "red";
      } else if (status === 5) {
        return "dark-blue";
      } else {
        return "gray";
      }
    }
  },
  computed: {
    getTranslation() {
      return condition => {
        if (condition === 1) {
          return this.$t("dropdown.condition1");
        } else {
          return this.$t("dropdown.condition2");
        }
      };
    },
    sortList() {
      return [
        {
          label: this.$t("profile.buyers.active"),
          value: "active"
        },
        {
          label: this.$t("profile.buyers.gave-up"),
          value: "gave-up"
        },
        {
          label: this.$t("profile.buyers.rejected"),
          value: "rejected"
        }
      ];
    }
  },
  watch: {
    sortSelected: {
      handler() {
        this.$emit("changeSort", this.sortSelected);
      }
    },
    search: {
      handler() {
        this.$emit("changeSearch", this.search);
      }
    },
    page: {
      handler() {
        this.$emit("changePage", this.page);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
@import "@/assets/scss/tableStyles.scss";
.profile-my-purchases-mobile-wrapper {
  .empty {
    text-align: left;
  }

  .full-width {
    width: 100%;
  }

  table {
    border: none;
  }
  .dropdown-row {
    td {
      border-bottom: 1px solid #e8e8e8;
      height: 0px;
      padding: 0px;
      overflow: hidden;
      transition-duration: 0.3s;

      .dropdown {
        width: 100%;
        height: 0px;
        transition-duration: 0.3s;
      }
    }
  }
  .bold-td-text {
    font-weight: 700;
    font-size: 17px;
  }
  .regular-td-text {
    font-weight: 500;
    font-size: 14px;
  }
  .light-grey {
    color: #9b9b9b;
    text-align: right;
    /* vertical-align: top; */
    font-weight: 400;
    font-size: 13px;
  }
  .status-color {
    color: #8e3e4c;
    text-align: center;
    font-weight: 600;
    font-size: 13px;
    span {
      margin: 7px 0 0 15px;
      min-width: 17px;
    }
  }
  .flex-center-right {
    display: flex;
    align-items: initial;
    justify-content: flex-end;
  }
  .dropdown-row.active {
    cursor: default;
    td {
      border-bottom: none;
      height: auto;

      overflow: hidden;
      transition-duration: 0.3s;

      .dropdown {
        height: auto;
        transition-duration: 0.3s;
        border: 1px solid rgba(243, 243, 243, 0.7);
        box-sizing: border-box;
        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
        padding: 10px;

        .info {
          margin-bottom: 10px;
          display: flex;
          align-items: left;
          justify-content: flex-start;
          &:not(.rate) {
            padding-left: 25px;
          }

          .info-key {
            font-weight: normal;
            font-size: 16px;
            // font-size: 13px;
            // line-height: 21px;
            // color: #787878;
            color: $text-color;
            margin-right: 10px;
            white-space: nowrap;
          }
          .info-value {
            // font-weight: 800;
            font-size: 16px;
            // font-size: 13px;
            // line-height: 21px;
            // letter-spacing: 0.02em;
            color: $text-color;
            .share-network-email {
              position: relative;
              .imgShareIcon {
                // position: relative;
                // bottom:-8px;
                position: relative;
                bottom: -4px;
                cursor: pointer;
                height: 35px;
                margin-left: 5px;
              }
            }
          }
          .iconsVal {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .dropdown-header {
          display: flex;
          flex-direction: column;
          align-items: center;

          .header {
            font-weight: bold;
            font-size: 17px;
            line-height: 28px;
            letter-spacing: 0.06em;
            text-transform: uppercase;
          }
          div {
            margin-bottom: 15px;
          }
        }
        .info-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          margin-bottom: 15px;

          .left {
            width: 100%;
            // display: flex;
            // flex-direction: column;
            // align-items: center;
          }
          .right {
            width: 100%;
            // display: flex;
            // flex-direction: column;
            // align-items: center;
          }
        }
        .rate-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          textarea {
            flex-grow: 1;
            resize: none;
          }
        }
      }
    }
  }
  tr.deleted td {
    // background: rgba(196, 196, 196, 0.15);
    display: relative;
    height: 88px;
  }
  tr.deleted {
    background: rgba(196, 196, 196, 0.15);
  }
  tbody tr td {
    border-bottom: none;
    /* vertical-align: top; */
    position: relative;
  }
  tbody tr {
    cursor: pointer;
    .remove-btn {
      position: absolute;
      top: 8px;
      right: 10px;
    }
    .iconsRemove {
      margin-top: 0;
      margin-left: 0;
      margin-right: 7px;
      padding-top: 2px;
      display: flex;
      justify-content: center;
      height: initial;
      img {
        width: 12px;
        height: 12px;
      }
    }
    .spanNull {
      margin: 0 0 0 0 !important;
      width: 0 px !important;
      height: 1px;
      background: red;
    }
  }
  .actions-wrapper {
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    .btn {
      width: 100%;
    }

    input {
      border: none;
      border-bottom: 1px solid #ddd;
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      height: 20px;
      line-height: 20px;
      padding: 9px;
      font-weight: bold;
      font-size: 13px;
      line-height: 15px;
      letter-spacing: 0.02em;
      color: $text-color;
      width: 100%;
      margin: 15px 0 30px;
    }
    input:focus {
      outline: none;
    }
    .btn {
      width: 170px;
    }
  }
  .search-wrapper {
    width: 100%;
    margin-top: 20px;
  }
  /*@media only screen and (max-width: 768px){
    .actions-wrapper {
      flex-direction: column;
      .btn {
        margin-bottom: 40px;
      }
    }
  }*/
  // vidite da li je bolje ovako kada su manji ekrani
  /*@media only screen and (max-width: 400px){
    tr {
      display: flex;
      flex-direction: column;
    }
    tr td{
      text-align: center!important;
    }
  }*/
}
</style>
